module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAA/0lEQVQoU8WRPUsDURBFzw0aEPzoLP0XWtissAHBSuy0sLF4a5nSJghprGzf7sNGrBRBsBDstBJbQfwNgtiaXd19kpWEzZKkdbqZe2aYOyNqYa1dk7QSRdF1VVI1cc61vPe3wBxwZIw5GehDMI7jLUk3QLPS3DHGdPt5CSZJsg1cAbP1VYCuMaYja+2mpDtJjTFQWZJ0IOfcalEUrUlQv57n+eOImWnwf4Ke9eWU5i74ya4p7tUjaAudTjMCHMuzMZPhL0E742H/9kMRlq49NDKCC9BeDX795iuc5/l95DwpwTlo/w/2LykKF3n4GP66OiUjOPSw0CM7W+Lpc6D9AhstSJ3hYScXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/mall/desc.png
// module id = Jaex
// module chunks = 1